import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { Paragraph } from '../../styles/text';

const Container = styled(Paragraph)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 28px;
  line-height: 28px;
  padding: 0 10px;
  margin-left: 2px;
  margin-right: 2px;
  box-sizing: border-box;
  border-radius: 14px;
  background-color: ${({ isNew }) => (isNew ? Colors.linear06 : Colors.violet)};
  color: ${Colors.shade08};
  
  span {
    cursor: pointer;
  }
`;

export {
  // eslint-disable-next-line import/prefer-default-export
  Container,
};
